import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { hasReadPermission } from '../service/userService';
import { HttpService, SystemTile } from '../library';

const DashboardAdvantage = () => {
    const [menus, setMenus] = useState([]);
    const getMenus = async () => {
        await HttpService.get("Menu/MenuList").then((response) => {
            setMenus(response.data);
        }).catch((error) => {
            console.log(error);
        })
    }
    useEffect(() => {
        getMenus();
    }, [])

    return (<>
        <div className="DashboardWrapperChild">
            <div className="contentWrapper">
                <HeaderDashboard title="Trailboss Advantage" tagLine="" />
                <div className="container-fluid mt-80">
                    <div className="row">
                        {menus.length > 0 ? menus.map((menu) => {
                            let actionlink = null;
                            if (menu.Application != null) {
                                if (menu.Application.Type.includes('Internal') || menu.Application.Type.includes('Local')) {
                                    actionlink = menu.Application.Action;
                                } else if (menu.Application !== null && menu.Application.Type.includes('External')) {
                                    actionlink = menu.Application.Action;
                                } else {
                                    if (menu.Application.File != undefined) {
                                        actionlink = menu.Application.File.FileUrl;
                                    } else {
                                        actionlink = "";
                                    }
                                }
                            }
                            else if (menu.IsFormMenu) {
                                actionlink = "/forms?menuId=" + menu.MenuId+'&form='+menu.Name;
                            }
                            return <>
                                {
                                    menu.Application != null || menu.IsFormMenu == true ?
                                        <SystemTile title={menu.Name}
                                            description={menu.Description}
                                            icon={menu.IconClass}
                                            link={actionlink}
                                            securityObject={menu.SecurityObject ? menu.SecurityObject.Name : false}
                                        />
                                        : null
                                }
                            </>
                        }) : ''}
                    </div>

                </div>
            </div>
        </div>
    </>)
}

export default DashboardAdvantage;